__webpack_require__.p = "/armedforces/";